import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AlertSettings } from 'src/app/alert/alert.service';
import { GeneralFunctionsService } from 'src/app/services/general-functions.service';
import { DataOptions } from 'src/app/models/application-models/data-options';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-common-modal',
  templateUrl: './common-modal.component.html',
  styleUrls: ['./common-modal.component.css']
})
export class CommonModalComponent implements OnDestroy {
  @Input() modalRef: NgbModalRef;
  @Input() dataOptions: DataOptions;

  @Output() loadingStatus = new EventEmitter<any>();
  @Output() transactionOk = new EventEmitter<any>();

  loadingAction: boolean;

  alertMain: AlertSettings;

  actionSubscription: Subscription;

  constructor(
    private generalFunctionsService: GeneralFunctionsService
  ) { }

  runAction(){
    this.loadingAction = true;
    this.loadingStatus.emit(this.loadingAction);
    this.actionSubscription = this.dataOptions.action.subscribe({
      next: ()=>{
        this.loadingAction = false;
        if (this.dataOptions.successMessage !== '') {
          this.generalFunctionsService.showSuccess(this.dataOptions.successMessage);
        }
        this.loadingStatus.emit(this.loadingAction);
        this.transactionOk.emit();
        this.close();
      },
      error: (error: any)=>{
        this.loadingAction = false;
        this.generalFunctionsService.handleError(error);
        this.loadingStatus.emit(this.loadingAction);
        this.close();
      }
    })
  }

  close(){
    this.modalRef.close();
  }

  ngOnDestroy(){
    if(this.actionSubscription) this.actionSubscription.unsubscribe();
  }
}
